import { toast } from '@codes/ui-kit/components/ui/use-toast';
import { useSelectedStore } from '@web/app/shared';

import { fetchOwner, useOwnerStore } from '@codes/owner';

export const useOwner = () => {
    const setOwner = useOwnerStore(state => state.setOwner);
    const [setWorkspace, setProject, project] = useSelectedStore(state => [
        state.setWorkspace,
        state.setProject,
        state.project,
    ]);

    const fetchAndSetOwner = async () => {
        try {
            const owner = await fetchOwner();
            setOwner(owner);

            return owner;
            // setWorkspace(owner.$workspace || null);
            // setProject(owner.$project || null);
        } catch (error) {
            console.error('Failed to fetch Owner:', error);
            toast({
                title: 'Failed to fetch Owner',
                duration: 2000,
            });
        }
    };

    return { fetchAndSetOwner };
};
